import React, { useRef } from "react";
import useDevice from "../../hooks/useDevice";
import EventTileSkeleton from "./EventTileSkeleton";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";

function Box({ children }) {
  return (
    <div
      style={{
        display: "block",
        lineHeight: 1,
        width: "100%",
      }}
    >
      {children}
    </div>
  );
}

const EventsSectionsSkeleton = () => {
  const { isMobile } = useDevice();
  let ref = useRef();

  return (
    <div
      id="r_eventsSection"
      style={{
        display: "flex",
        flexDirection: "column",
        margin: "0 16px",
        gap: 24,
      }}
    >
      <SkeletonTheme
        baseColor="#D8DBE0"
        highlightColor="#EDF1F6"
        borderRadius={"4px"}
      >
        <Skeleton wrapper={Box} width={124} height={16} />
      </SkeletonTheme>
      <div
        ref={ref}
        style={{
          display: "flex",
          gap: 16,
          overflowX: "hidden",
          scrollSnapType: "x mandatory",
          paddingBottom: 24,
        }}
      >
        <EventTileSkeleton vertical={isMobile} />
        <EventTileSkeleton vertical={isMobile} />
      </div>
    </div>
  );
};

export default EventsSectionsSkeleton;
